module.exports = __webpack_public_path__ + "static/media/AddwitnessSelected.42db3d9e.svg";